/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'phone_red': {
    width: 11,
    height: 16,
    viewBox: '0 0 11 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M6.266 11.903c1.159-.829 1.84-1.023 3.403.116 1.749 1.274 2.073 2.734-.867 3.981C3.048 15.5-1.808 6.625.658 1.117 3.15-.946 4.188.08 4.358 2.315c.154 1.997-.346 2.523-1.607 3.168.174 2.413 1.62 5.055 3.514 6.42z" _fill="#9C380E"/>'
  }
})
